import React from 'react'
export const TwoLoopsImg = ({ width, height }) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 286 287" fill="none">
  <path d="M2.2019 284.318C312.423 -91.7075 -167.009 -91.7075 143.211 284.318C453.432 -91.7075 -26 -91.7075 284.221 284.318" stroke="black" strokeWidth="3.44481" strokeLinejoin="round"/>
</svg>
  )
}
